import { syncPodiumScenes } from './3os-281-podium.js';
import { syncProofScene } from './3os-282-grounding.js';
const __vite__mapDeps = (
  i,
  m = __vite__mapDeps,
  d = m.f ||
    (m.f = [
      "./3os-270-GLTFLoader-D1mcXGyd.js",
      "./3os-270-three.module-CbbBeXoY.js",
      "./3os-270-OrbitControls-0rI7sN85.js",
      "./3os-270-RoomEnvironment-GMpwNQdR.js",
    ]),
) => i.map((i) => d[i]);
var e = `modulepreload`,
  t = function (e, t) {
    return new URL(e, t).href;
  },
  n = {},
  r = function (r, i, a) {
    let o = Promise.resolve();
    if (i && i.length > 0) {
      let r = document.getElementsByTagName(`link`),
        s = document.querySelector(`meta[property=csp-nonce]`),
        c = s?.nonce || s?.getAttribute(`nonce`);
      function l(e) {
        return Promise.all(
          e.map((e) =>
            Promise.resolve(e).then(
              (e) => ({ status: `fulfilled`, value: e }),
              (e) => ({ status: `rejected`, reason: e }),
            ),
          ),
        );
      }
      o = l(
        i.map((i) => {
          if (((i = t(i, a)), i in n)) return;
          n[i] = !0;
          let o = i.endsWith(`.css`),
            s = o ? `[rel="stylesheet"]` : ``;
          if (a)
            for (let e = r.length - 1; e >= 0; e--) {
              let t = r[e];
              if (t.href === i && (!o || t.rel === `stylesheet`)) return;
            }
          else if (document.querySelector(`link[href="${i}"]${s}`)) return;
          let l = document.createElement(`link`);
          if (
            ((l.rel = o ? `stylesheet` : e),
            o || (l.as = `script`),
            (l.crossOrigin = ``),
            (l.href = i),
            c && l.setAttribute(`nonce`, c),
            document.head.appendChild(l),
            o)
          )
            return new Promise((e, t) => {
              (l.addEventListener(`load`, e),
                l.addEventListener(`error`, () =>
                  t(Error(`Unable to preload CSS for ${i}`)),
                ));
            });
        }),
      );
    }
    function s(e) {
      let t = new Event(`vite:preloadError`, { cancelable: !0 });
      if (((t.payload = e), window.dispatchEvent(t), !t.defaultPrevented))
        throw e;
    }
    return o.then((e) => {
      for (let t of e || []) t.status === `rejected` && s(t.reason);
      return r().catch(s);
    });
  },
  i = window.__THREE_OLIVES_270__ || {},
  a = 324.76015,
  o = Object.freeze({ 500: 257.740324, 1e3: 324.76015 }),
  s = 1;
if (
  i.enabled &&
  (i.mobile !== !1 || !window.matchMedia(`(max-width: 749px)`).matches)
) {
  let e = new Map(),
    t = new WeakSet(),
    n = new Map(),
    c = new Map(),
    l = new WeakSet(),
    u = i.models || {},
    d = i.posters || {},
    f =
      navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection,
    p = window.matchMedia(`(prefers-reduced-motion: reduce)`),
    m =
      i.prewarm !== !1 &&
      new URLSearchParams(location.search).get(`three_olives_prewarm`) !==
        `0` &&
      !f?.saveData &&
      ![`slow-2g`, `2g`].includes(f?.effectiveType),
    h = {
      release: `290-R6-media`,
      enhanced: 0,
      activeCount: 0,
      runtimeLoaded: !1,
      activations: 0,
      modelRequests: 0,
      modelsLoaded: 0,
      modelPreloads: 0,
      prewarmCompleted: 0,
      surfaceRefreshes: 0,
      lastActivationMs: 0,
      failures: 0,
    };
  class g {
    constructor() {
      ((this.THREE = null),
        (this.renderer = null),
        (this.scene = null),
        (this.camera = null),
        (this.controls = null),
        (this.loader = null),
        (this.rendererFactory = null),
        (this.ControlsClass = null),
        (this.RoomEnvironmentClass = null),
        (this.runtimePromise = null),
        (this.activeRecord = null),
        (this.activeModel = null),
        (this.activeGround = null),
        (this.resizeObserver = null),
        (this.activationToken = 0),
        (this.home = null),
        (this.lights = {}),
        (this.surfaceNeedsRefresh = !1),
        (this.webkitSurfaceRefresh =
          /AppleWebKit/i.test(navigator.userAgent) &&
          (!/(?:Chrome|Chromium|Edg|OPR)/i.test(navigator.userAgent) ||
            /iP(?:hone|ad|od)/i.test(navigator.userAgent))));
    }
    async ensureRuntime() {
      if (!this.renderer)
        return (
          (this.runtimePromise ||= this.createRuntime().catch((e) => {
            throw ((this.runtimePromise = null), e);
          })),
          this.runtimePromise
        );
    }
    async createRuntime() {
      let [e, t, n, i, a] = await Promise.all([
        r(
          () => import(`./3os-270-three.module-CbbBeXoY.js`),
          [],
          import.meta.url,
        ),
        r(
          () => import(`./3os-270-GLTFLoader-D1mcXGyd.js`),
          __vite__mapDeps([0, 1]),
          import.meta.url,
        ),
        r(
          () => import(`./3os-270-OrbitControls-0rI7sN85.js`),
          __vite__mapDeps([2, 1]),
          import.meta.url,
        ),
        r(
          () => import(`./3os-270-RoomEnvironment-GMpwNQdR.js`),
          __vite__mapDeps([3, 1]),
          import.meta.url,
        ),
        r(
          () => import(`./3os-270-meshopt_decoder.module-DXTYc6wn.js`),
          [],
          import.meta.url,
        ),
      ]);
      ((this.THREE = e),
        (this.loader = new t.GLTFLoader()),
        this.loader.setMeshoptDecoder(a.MeshoptDecoder),
        (this.ControlsClass = n.OrbitControls),
        (this.RoomEnvironmentClass = i.RoomEnvironment),
        (this.home = {
          position: new e.Vector3(),
          target: new e.Vector3(),
          yaw: 0,
        }),
        (this.rendererFactory = () =>
          new e.WebGLRenderer({
            alpha: !0,
            antialias: !0,
            powerPreference: `high-performance`,
            premultipliedAlpha: !0,
          })),
        (this.renderer = this.rendererFactory()),
        this.renderer.setClearColor(0, 0),
        this.renderer.setPixelRatio(
          Math.min(window.devicePixelRatio || 1, 1.5),
        ),
        (this.renderer.outputColorSpace = e.SRGBColorSpace),
        (this.renderer.toneMapping = e.ACESFilmicToneMapping),
        (this.renderer.toneMappingExposure = 0.88),
        (this.renderer.shadowMap.enabled = !0),
        (this.renderer.shadowMap.type = e.PCFShadowMap));
      let o = this.renderer.domElement;
      ((o.className = `three-olives-270__canvas`),
        (o.tabIndex = 0),
        o.setAttribute(`role`, `application`),
        o.addEventListener(`keydown`, (e) => this.onKeydown(e)),
        o.addEventListener(`click`, (e) => e.stopPropagation()));
      let s = this.renderer;
      (o.addEventListener(`webglcontextlost`, (e) => {
        (e.preventDefault(),
          this.renderer === s &&
            this.fail(
              this.activeRecord,
              `Vizualizarea 3D a fost întreruptă. Imaginea produsului rămâne disponibilă.`,
            ));
      }),
        (this.scene = new e.Scene()),
        (this.camera = new e.PerspectiveCamera(25, 1, 0.001, 50)),
        (this.controls = new this.ControlsClass(this.camera, o)),
        (this.controls.enablePan = !1),
        (this.controls.enableDamping = !1),
        (this.controls.rotateSpeed = 0.66),
        (this.controls.zoomSpeed = 0.78),
        (this.controls.minPolarAngle = Math.PI * 0.31),
        (this.controls.maxPolarAngle = Math.PI * 0.69),
        this.controls.addEventListener(`change`, () => this.render()),
        this.controls.addEventListener(`start`, () =>
          this.setStatus(`Rotești sticla ${this.activeRecord?.label || ``}.`),
        ),
        this.controls.addEventListener(`end`, () =>
          this.setStatus(
            `Sticla ${this.activeRecord?.label || ``} este poziționată.`,
          ),
        ));
      let c = new this.RoomEnvironmentClass(),
        l = new e.PMREMGenerator(this.renderer);
      ((this.scene.environment = l.fromScene(c, 0.04).texture),
        l.dispose(),
        c.dispose(),
        (this.lights.key = new e.DirectionalLight(16771002, 2.35)),
        this.lights.key.position.set(2.7, 3.5, 4.8),
        (this.lights.key.castShadow = !0),
        this.lights.key.shadow.mapSize.set(512, 512),
        (this.lights.key.shadow.bias = -12e-5),
        (this.lights.fill = new e.DirectionalLight(13229522, 1.08)),
        this.lights.fill.position.set(-3.6, 1.4, 2.5),
        (this.lights.rim = new e.DirectionalLight(14923839, 0.92)),
        this.lights.rim.position.set(2.8, 1.7, -3.6),
        (this.lights.ambient = new e.AmbientLight(16777215, 0.38)),
        Object.values(this.lights).forEach((e) => this.scene.add(e)),
        (h.runtimeLoaded = !0));
    }
    refreshRendererSurface() {
      if (
        !this.webkitSurfaceRefresh ||
        !this.surfaceNeedsRefresh ||
        !this.rendererFactory
      )
        return;
      (this.controls?.dispose(),
        this.renderer?.dispose(),
        this.renderer?.forceContextLoss?.(),
        this.scene.environment?.dispose?.(),
        (this.renderer = this.rendererFactory()),
        this.renderer.setClearColor(0, 0),
        this.renderer.setPixelRatio(
          Math.min(window.devicePixelRatio || 1, 1.5),
        ),
        (this.renderer.outputColorSpace = this.THREE.SRGBColorSpace),
        (this.renderer.toneMapping = this.THREE.ACESFilmicToneMapping),
        (this.renderer.toneMappingExposure = 0.88),
        (this.renderer.shadowMap.enabled = !0),
        (this.renderer.shadowMap.type = this.THREE.PCFShadowMap));
      let e = this.renderer.domElement;
      ((e.className = `three-olives-270__canvas`),
        (e.tabIndex = 0),
        e.setAttribute(`role`, `application`),
        e.addEventListener(`keydown`, (e) => this.onKeydown(e)),
        e.addEventListener(`click`, (e) => e.stopPropagation()));
      let t = this.renderer;
      (e.addEventListener(`webglcontextlost`, (e) => {
        (e.preventDefault(),
          this.renderer === t &&
            this.fail(
              this.activeRecord,
              `Vizualizarea 3D a fost întreruptă. Imaginea produsului rămâne disponibilă.`,
            ));
      }),
        (this.controls = new this.ControlsClass(this.camera, e)),
        (this.controls.enablePan = !1),
        (this.controls.enableDamping = !1),
        (this.controls.rotateSpeed = 0.66),
        (this.controls.zoomSpeed = 0.78),
        (this.controls.minPolarAngle = Math.PI * 0.31),
        (this.controls.maxPolarAngle = Math.PI * 0.69),
        this.controls.addEventListener(`change`, () => this.render()),
        this.controls.addEventListener(`start`, () =>
          this.setStatus(`Rotești sticla ${this.activeRecord?.label || ``}.`),
        ),
        this.controls.addEventListener(`end`, () =>
          this.setStatus(
            `Sticla ${this.activeRecord?.label || ``} este poziționată.`,
          ),
        ));
      let n = new this.RoomEnvironmentClass(),
        r = new this.THREE.PMREMGenerator(this.renderer);
      ((this.scene.environment = r.fromScene(n, 0.04).texture),
        r.dispose(),
        n.dispose(),
        (this.surfaceNeedsRefresh = !1),
        (h.surfaceRefreshes += 1));
    }
    resolveModelUrl(e) {
      let t = typeof e == `string` ? e : e.modelUrl;
      return new URL(t, document.baseURI).href;
    }
    fetchModelBytes(e, { preload: t = !1 } = {}) {
      let n = this.resolveModelUrl(e);
      if (!c.has(n)) {
        ((h.modelRequests += 1), t && (h.modelPreloads += 1));
        let e = fetch(n, { credentials: `same-origin`, cache: `force-cache` })
          .then(async (e) => {
            if (!e.ok) throw Error(`Model request failed with ${e.status}`);
            let t = Number(e.headers.get(`content-length`)) || 0;
            if (!e.body || !t) return e.arrayBuffer();
            let r = e.body.getReader(),
              i = [],
              a = 0;
            for (;;) {
              let { done: e, value: o } = await r.read();
              if (e) break;
              (i.push(o),
                (a += o.byteLength),
                this.activeRecord &&
                  n === this.resolveModelUrl(this.activeRecord) &&
                  this.setStatus(
                    `Se încarcă sticla ${this.activeRecord.label}: ${Math.min(100, Math.round((a / t) * 100))}%.`,
                  ));
            }
            let o = new Uint8Array(a),
              s = 0;
            for (let e of i) (o.set(e, s), (s += e.byteLength));
            return o.buffer;
          })
          .catch((e) => {
            throw (c.delete(n), e);
          });
        c.set(n, e);
      }
      return c.get(n);
    }
    async getModel(e) {
      let t = this.resolveModelUrl(e);
      if (!n.has(t)) {
        let r = new URL(`.`, t).href,
          i = this.fetchModelBytes(e)
            .then((e) => this.loader.parseAsync(e, r))
            .then(
              (e) => (
                this.prepareModel(e.scene),
                (h.modelsLoaded += 1),
                e.scene
              ),
            )
            .catch((e) => {
              throw (n.delete(t), e);
            });
        n.set(t, i);
      }
      return n.get(t);
    }
    prepareModel(e) {
      if (e.userData.threeOlivesPreparedR2) return;
      e.traverse((e) => {
        e.isMesh &&
          ((e.castShadow = !0),
          (e.receiveShadow = !0),
          (Array.isArray(e.material) ? e.material : [e.material])
            .filter(Boolean)
            .forEach((e) => {
              (e.map &&
                ((e.map.colorSpace = this.THREE.SRGBColorSpace),
                (e.map.anisotropy = Math.min(
                  8,
                  this.renderer.capabilities.getMaxAnisotropy(),
                ))),
                this.calibrateBottleMaterial(e),
                (e.needsUpdate = !0));
            }));
      });
      let t = new this.THREE.Box3().setFromObject(e),
        n = t.getSize(new this.THREE.Vector3()),
        r = t.getCenter(new this.THREE.Vector3());
      (e.position.sub(r),
        (e.userData.threeOlivesSourceHeight = Math.max(1e-6, n.y)),
        (e.userData.threeOlivesSourceCenter = r.clone()),
        (e.userData.threeOlivesPreparedR2 = !0));
    }
    calibrateBottleMaterial(e) {
      if(/^3OS R6 \|/.test(e.name||''))return;
      // Retain both repaired R5 material sets. The gold paper is calibrated
      // against Radu's approved R10 render, not the retired 270 artwork.
      if(/^3OS R5 \|/.test(e.name||'')){
        if(/triathlon original printed label/.test(e.name))e.color.setScalar(.62);
        if(/tennis original printed label/.test(e.name))e.color.setScalar(.55);
        return;
      }
      let t = String(e.name || ``);
      // 281: match the supplied Tennis artwork to this site's bright studio rig.
      // Scoped by the V3 material name; the original GLB and every 1 L material stay intact.
      if (/^3OS V3 \| tennis original printed label$/i.test(t)) {
        const balance = Math.max(0.2, Math.min(1, Number(i.v3LabelReflectance) || 0.38));
        e.color?.setScalar(balance);
        e.roughness = 0.78;
        e.specularIntensity = 0.1;
        e.envMapIntensity = 0.65;
        // Paper still receives physical lighting; omit the filmic shoulder that washes out its ink.
        e.toneMapped = false;
      }
      if (
        (/Dark Green Glass/i.test(t) &&
          (e.color?.set(`#163d2a`),
          (e.roughness = 0.18),
          (e.metalness = 0),
          (e.transmission = Math.max(0.32, Number(e.transmission) || 0)),
          (e.thickness = Math.max(0.48, Number(e.thickness) || 0)),
          (e.ior = 1.48),
          (e.clearcoat = 0.5),
          (e.clearcoatRoughness = 0.08),
          (e.envMapIntensity = 1.32),
          `specularIntensity` in e && (e.specularIntensity = 0.94),
          e.attenuationColor && e.attenuationColor.set(`#315a3b`),
          `attenuationDistance` in e && (e.attenuationDistance = 1.8),
          (e.side = this.THREE.FrontSide)),
        /Picual Oil/i.test(t) &&
          (e.color?.set(`#4f3b10`),
          (e.roughness = 0.15),
          (e.transmission = Math.max(0.1, Number(e.transmission) || 0)),
          (e.clearcoat = 0.12),
          (e.clearcoatRoughness = 0.1),
          (e.envMapIntensity = 1.05),
          (e.side = this.THREE.FrontSide)),
        /Gold Label/i.test(t))
      ) {
        let t = e.map ? `#ffffff` : `#e2b763`;
        (e.color?.set(t),
          (e.roughness = 0.48),
          (e.clearcoat = 0.04),
          (e.clearcoatRoughness = 0.16),
          (e.envMapIntensity = 0.9));
      }
    }
    applyPhysicalScale(e, t) {
      let n = Math.max(1e-6, Number(e.userData.threeOlivesSourceHeight) || 1),
        r = Number(t.physicalScale) || 1,
        i = (s * r) / n;
      e.scale.setScalar(i);
      // KHR_materials_volume attenuationDistance uses world units. Normalizing
      // the native metre-scale bottle must normalize absorption distance too;
      // otherwise the approved optical glass becomes black at interaction.
      e.traverse(node => {
        if(!node.isMesh)return;
        for(const material of Array.isArray(node.material)?node.material:[node.material]){
          if(!material || !Number.isFinite(material.attenuationDistance))continue;
          material.userData.r11SourceAttenuation ??= material.attenuationDistance;
          material.attenuationDistance=material.userData.r11SourceAttenuation*i;
        }
      });
      let a = e.userData.threeOlivesSourceCenter;
      (a && e.position.copy(a).multiplyScalar(-i),
        (e.position.y -= (s * (1 - r)) / 2),
        e.updateMatrixWorld(!0));
    }
    async prewarm(e, { modelUrl: t = e?.modelUrl, compile: n = !0 } = {}) {
      if (!e || !t || !e.stage.isConnected) return !1;
      let r = this.resolveModelUrl(t),
        i = c.has(r);
      try {
        await Promise.all([
          this.ensureRuntime(),
          this.fetchModelBytes(t, { preload: !i }),
        ]);
        let r = await this.getModel(t);
        return (
          n && !this.activeRecord && (await this.precompileModel(r, e)),
          r.userData.threeOlivesPrewarmedR2 ||
            ((r.userData.threeOlivesPrewarmedR2 = !0),
            (h.prewarmCompleted += 1)),
          !0
        );
      } catch {
        return !1;
      }
    }
    async precompileModel(e, t) {
      if (!e.userData.threeOlivesCompiledR2)
        return (
          e.userData.threeOlivesCompilePromise ||
            (e.userData.threeOlivesCompilePromise = (async () => {
              let n = e.rotation.clone(),
                r = e.scale.clone(),
                i = e.position.clone();
              this.applyPhysicalScale(e, t);
              let a = new this.THREE.Box3().setFromObject(e),
                o = a.getSize(new this.THREE.Vector3()),
                s = Math.max(o.x, o.y, o.z),
                c = new this.THREE.Mesh(
                  new this.THREE.CircleGeometry(s * 0.46, 32),
                  new this.THREE.ShadowMaterial({
                    color: 534303,
                    opacity: this.shadowOpacity(t.tone),
                  }),
                );
              (e.rotation.set(0, t.yaw, 0),
                (c.rotation.x = -Math.PI / 2),
                (c.position.y = a.min.y - s * 0.006),
                (c.receiveShadow = !0),
                this.scene.add(e, c),
                this.applyTone(t.tone),
                (this.camera.aspect = 0.8));
              let l =
                (o.y * 0.5) /
                Math.tan(this.THREE.MathUtils.degToRad(this.camera.fov * 0.5));
              (this.camera.position.set(l * 0.035, o.y * 0.008, l * 1.14),
                this.camera.lookAt(0, 0, 0),
                this.camera.updateProjectionMatrix());
              try {
                (this.renderer.compile(this.scene, this.camera),
                  this.renderer.render(this.scene, this.camera),
                  (e.userData.threeOlivesCompiledR2 = !0));
              } finally {
                (this.scene.remove(e, c),
                  c.geometry.dispose(),
                  c.material.dispose(),
                  e.rotation.copy(n),
                  e.scale.copy(r),
                  e.position.copy(i),
                  delete e.userData.threeOlivesCompilePromise);
              }
            })()),
          e.userData.threeOlivesCompilePromise
        );
    }
    async activate(e, { focus: t = !0 } = {}) {
      if (!e || !e.stage.isConnected || !b(e.stage)) return;
      if (e === this.activeRecord) {
        t && this.renderer?.domElement.focus({ preventScroll: !0 });
        return;
      }
      (this.deactivate({ silent: !0 }), this.refreshRendererSurface());
      let n = performance.now(),
        r = ++this.activationToken;
      ((this.activeRecord = e),
        (h.activeCount = 1),
        (h.activations += 1),
        e.stage.classList.remove(`is-error`, `is-fallback`, `is-ready`),
        e.stage.classList.add(`is-active`, `is-loading`),
        (e.stage.dataset.threeOlivesViewerState = `loading`),
        (e.controls.hidden = !0),
        this.setStatus(`Se încarcă sticla ${e.label} în 3D.`));
      try {
        if (
          (await Promise.all([this.ensureRuntime(), this.fetchModelBytes(e)]),
          r !== this.activationToken || e !== this.activeRecord)
        )
          return;
        (T(e), e.mount.append(this.renderer.domElement),
          this.renderer.domElement.setAttribute(
            `aria-label`,
            `Model 3D interactiv: sticla 3 Olives Society Picual ${e.label}. Trage pentru rotire; folosește săgețile, plus, minus, Home și Escape.`,
          ),
          this.applyTone(e.tone),
          this.watchSize(e),
          this.resize());
        let i = await this.getModel(e);
        if (
          (i.userData.threeOlivesCompilePromise &&
            (await i.userData.threeOlivesCompilePromise),
          r !== this.activationToken || e !== this.activeRecord)
        )
          return;
        (this.mountModel(i, e),
          e.stage.classList.remove(`is-loading`),
          e.stage.classList.add(`is-ready`),
          (e.stage.dataset.threeOlivesViewerState = `active`),
          (e.controls.hidden = e.compact || !e.pendingRotation),
          this.setStatus(
            `Sticla ${e.label} este activă în 3D. Trage pentru a o roti.`,
          ),
          this.render(),
          (h.lastActivationMs = Math.round(performance.now() - n)),
          t && this.renderer.domElement.focus({ preventScroll: !0 }));
      } catch (t) {
        if (r !== this.activationToken) return;
        (console.error(`[3OS 270-R2] Model load failed`, t),
          (h.failures += 1),
          this.fail(
            e,
            `Modelul 3D pentru ${e.label} nu s-a putut încărca. Imaginea produsului rămâne disponibilă.`,
          ));
      }
    }
    mountModel(e, t) {
      (this.activeModel && this.scene.remove(this.activeModel),
        this.removeGround(),
        (this.activeModel = e),
        this.scene.add(e),
        this.applyPhysicalScale(e, t),
        e.rotation.set(0, t.yaw + (t.pendingRotation || 0), 0));
      let n = new this.THREE.Box3().setFromObject(e),
        r = n.getSize(new this.THREE.Vector3()),
        i = Math.max(r.x, r.y, r.z),
        a = new this.THREE.Mesh(
          new this.THREE.CircleGeometry(i * 0.46, t.compact ? 32 : 64),
          new this.THREE.ShadowMaterial({
            color: 534303,
            opacity: this.shadowOpacity(t.tone),
          }),
        );
      ((a.rotation.x = -Math.PI / 2),
        (a.position.y = n.min.y - i * 0.006),
        (a.receiveShadow = !0),
        this.scene.add(a),
        (this.activeGround = a));
      this.perspectiveCamera ||= this.camera;
      if (t.poster) {
        this.podiumCamera ||= new this.THREE.OrthographicCamera(-1,1,1,-1,.01,30);
        this.camera = this.podiumCamera;
        this.controls.object = this.camera;
        this.activeGround.visible = false;
        this.fitPodiumCamera();
        return;
      }
      this.camera = this.perspectiveCamera;
      this.controls.object = this.camera;
      this.camera.aspect = Math.max(1,t.mount.clientWidth)/Math.max(1,t.mount.clientHeight);
      let o = Math.max(0.24, this.camera.aspect),
        c =
          (s * 0.5) /
          Math.tan(this.THREE.MathUtils.degToRad(this.camera.fov * 0.5)),
        l =
          2 *
          Math.atan(
            Math.tan(this.THREE.MathUtils.degToRad(this.camera.fov * 0.5)) * o,
          ),
        u = (s * 0.18) / Math.tan(l * 0.5),
        d = Math.max(1, 0.8 / o),
        f = Math.max(c, u) * t.fit * d;
      ((this.camera.near = Math.max(5e-4, f / 120)),
        (this.camera.far = Math.max(10, f * 24)),
        this.camera.position.set(f * 0.035, 0, f),
        this.camera.updateProjectionMatrix(),
        this.controls.target.set(0, 0, 0),
        (this.controls.minDistance = f * 0.72),
        (this.controls.maxDistance = f * 1.42),
        (this.controls.enableZoom = !t.compact && t.zoom),
        this.controls.update(),
        this.home.position.copy(this.camera.position),
        this.home.target.copy(this.controls.target),
        (this.home.yaw = t.yaw));
    }
    fitPodiumCamera() {
      const record=this.activeRecord, geometry=record?.stage.__podiumGeometry||this.posterGeometry(record);
      if(!geometry || !this.camera?.isOrthographicCamera || !this.activeModel)return;
      const width=record.mount.clientWidth, height=record.mount.clientHeight;
      if(!width||!height)return;
      // Orthographic product framing: a rotation cannot lift or sink the base.
      // Both formats retain their physical height ratio, without poster padding.
      const unit=record.physicalScale/geometry.visibleHeight;
      const spanX=width*unit, spanY=height*unit;
      const centerY=-.5+(geometry.visibleHeight+geometry.topGap-height*.5)*unit;
      Object.assign(this.camera,{left:-spanX*.5,right:spanX*.5,top:spanY*.5,bottom:-spanY*.5,zoom:1});
      const centerX=(geometry.centerOffsetX||0)*unit;
      this.camera.position.set(centerX,centerY,6);
      this.controls.target.set(centerX,centerY,0);
      this.controls.enableZoom=record.zoom;
      this.camera.updateProjectionMatrix();
      this.controls.update();
      this.home.position.copy(this.camera.position);
      this.home.target.copy(this.controls.target);
      this.home.yaw=record.yaw;
    }
    posterGeometry(record) {
      if(!record?.poster||!record.mount)return null;
      const p=record.poster.getBoundingClientRect(),m=record.mount.getBoundingClientRect();
      if(!p.width||!p.height||!m.width||!m.height)return null;
      const fit=getComputedStyle(record.poster).objectFit;
      let width=p.width,height=p.height;
      if(fit==='contain'||fit==='cover'){
        const scale=(fit==='cover'?Math.max:Math.min)(p.width/1120,p.height/1400);
        width=1120*scale;height=1400*scale;
      }
      return {visibleHeight:height*1055/1400,topGap:p.top+(p.height-height)/2-m.top+height*166/1400,centerOffsetX:m.left+m.width/2-(p.left+p.width/2),source:'R11 shared RGBA product framing'};
    }
    applyTone(e = `sunlit`) {
      // One calibrated product studio on every background. Scene colours stay
      // in the approved HTML; the product does not change colour on activation.
      e='sunlit';
      let t = {
          sunlit: {
            exposure: 0.9,
            ambient: 0.38,
            key: [16771002, 2.35],
            fill: [13229522, 1.08],
            rim: [14923839, 0.92],
          },
          olive: {
            exposure: 1.08,
            ambient: 0.7,
            key: [16770232, 3],
            fill: [12113352, 1.8],
            rim: [15056195, 1.55],
          },
          green: {
            exposure: 1.02,
            ambient: 0.66,
            key: [16769976, 2.82],
            fill: [11062203, 1.62],
            rim: [15254092, 1.72],
          },
          paper: {
            exposure: 0.94,
            ambient: 0.4,
            key: [16771792, 2.18],
            fill: [14148573, 1.18],
            rim: [13212450, 0.78],
          },
        },
        n = t[e] || t.sunlit;
      ((this.renderer.toneMappingExposure = n.exposure),
        (this.lights.ambient.intensity = n.ambient),
        [
          [`key`, n.key],
          [`fill`, n.fill],
          [`rim`, n.rim],
        ].forEach(([e, t]) => {
          (this.lights[e].color.setHex(t[0]),
            (this.lights[e].intensity = t[1]));
        }));
    }
    shadowOpacity(e) {
      return e === `green`
        ? 0.14
        : e === `olive`
          ? 0.17
          : e === `paper`
            ? 0.15
            : 0.2;
    }
    rotate(e) {
      this.activeModel &&
        ((this.activeModel.rotation.y += (e * Math.PI) / 10),
        this.markRotated(),
        this.setStatus(
          `Sticla ${this.activeRecord.label} a fost rotită ${e < 0 ? `spre stânga` : `spre dreapta`}.`,
        ),
        this.render());
    }
    rotateByPixels(e, t = this.activeRecord) {
      if (!t || !Number.isFinite(e) || e === 0) return;
      let n = e * 0.012;
      ((t.pendingRotation = (t.pendingRotation || 0) + n),
        t === this.activeRecord &&
          this.activeModel &&
          (this.activeModel.rotation.y += n),
        this.markRotated(t),
        this.render());
    }
    markRotated(e = this.activeRecord) {
      e &&
        (e.stage.classList.add(`has-rotation`),
        (e.controls.hidden = e.compact));
    }
    zoom(e) {
      if (!this.camera || !this.controls || !this.activeRecord?.zoom) return;
      if(this.camera.isOrthographicCamera){
        this.camera.zoom=Math.max(1,Math.min(1.12,this.camera.zoom/e));
        this.camera.updateProjectionMatrix();this.render();return;
      }
      let t = this.camera.position
          .clone()
          .sub(this.controls.target)
          .multiplyScalar(e),
        n = t.length();
      n < this.controls.minDistance ||
        n > this.controls.maxDistance ||
        (this.camera.position.copy(this.controls.target).add(t),
        this.controls.update(),
        this.setStatus(
          `Zoom ${e < 1 ? `mărit` : `micșorat`} pentru sticla ${this.activeRecord.label}.`,
        ),
        this.render());
    }
    reset() {
      if(this.camera?.isOrthographicCamera){this.camera.zoom=1;this.camera.updateProjectionMatrix();}
      this.activeModel &&
        (this.activeModel.rotation.set(0, this.home.yaw, 0),
        (this.activeRecord.pendingRotation = 0),
        this.activeRecord.stage.classList.remove(`has-rotation`),
        (this.activeRecord.controls.hidden = !0),
        this.camera.position.copy(this.home.position),
        this.controls.target.copy(this.home.target),
        this.controls.update(),
        this.setStatus(
          `Sticla ${this.activeRecord.label} este din nou în poziția frontală.`,
        ),
        this.render());
    }
    deactivate({ silent: e = !1 } = {}) {
      ((this.activationToken += 1),
        this.resizeObserver?.disconnect(),
        (this.resizeObserver = null));
      let t = this.activeRecord;
      t &&
        (t.stage.classList.remove(`is-active`, `is-loading`, `is-ready`),
        t.stage.classList.remove(`has-rotation`),
        (t.pendingRotation = 0),
        (t.stage.dataset.threeOlivesViewerState = `poster`),
        (t.controls.hidden = !0),
        (t.status.textContent = e
          ? `Posterul sticlei ${t.label} este afișat.`
          : `Vizualizarea 3D pentru ${t.label} a fost închisă. Imaginea produsului este afișată.`),
        this.activeModel && this.scene.remove(this.activeModel),
        (this.activeModel = null),
        this.removeGround(),
        this.renderer?.domElement.remove(),
        (this.surfaceNeedsRefresh = this.webkitSurfaceRefresh),
        (this.activeRecord = null),
        (h.activeCount = 0));
    }
    fail(e, t) {
      e &&
        (e.stage.classList.remove(
          `is-active`,
          `is-loading`,
          `is-ready`,
          `is-error`,
        ),
        e.stage.classList.add(`is-fallback`),
        (e.stage.dataset.threeOlivesViewerState = `fallback`),
        (e.controls.hidden = !0),
        (e.status.textContent = t),
        this.activeModel && this.scene.remove(this.activeModel),
        (this.activeModel = null),
        this.removeGround(),
        this.renderer?.domElement.remove(),
        (this.surfaceNeedsRefresh = this.webkitSurfaceRefresh),
        this.activeRecord === e && (this.activeRecord = null),
        (h.activeCount = 0));
    }
    removeGround() {
      this.activeGround &&=
        (this.scene.remove(this.activeGround),
        this.activeGround.geometry.dispose(),
        this.activeGround.material.dispose(),
        null);
    }
    setStatus(e) {
      this.activeRecord && (this.activeRecord.status.textContent = e);
    }
    watchSize(e) {
      (this.resizeObserver?.disconnect(),
        (this.resizeObserver = new ResizeObserver(() => {
          (T(e), this.resize());
        })),
        this.resizeObserver.observe(e.stage),
        this.resizeObserver.observe(e.poster));
    }
    resize() {
      if (!this.renderer || !this.camera || !this.activeRecord) return;
      T(this.activeRecord);
      let { mount: e } = this.activeRecord,
        t = Math.max(1, Math.round(e.clientWidth)),
        n = Math.max(1, Math.round(e.clientHeight));
      ((this.camera.aspect = t / n),
        this.camera.updateProjectionMatrix(),
        // Fine label lines need supersampling even on a 1x desktop display.
        // One demand-rendered canvas, capped at 1.6 MP (DPR remains 1–2).
        this.renderer.setPixelRatio(Math.min(2,Math.max(1,Math.sqrt(1600000/(t*n))))),
        this.renderer.setSize(t, n, !1),
        this.fitPodiumCamera(),
        this.render());
    }
    render() {
      this.renderer &&
        this.scene &&
        this.camera &&
        this.activeRecord &&
        this.renderer.render(this.scene, this.camera);
    }
    onKeydown(e) {
      this.activeRecord &&
        (e.key === `ArrowLeft` && (e.preventDefault(), this.rotate(-1)),
        e.key === `ArrowRight` && (e.preventDefault(), this.rotate(1)),
        (e.key === `+` || e.key === `=`) &&
          (e.preventDefault(), this.zoom(0.9)),
        (e.key === `-` || e.key === `_`) &&
          (e.preventDefault(), this.zoom(1.1)),
        e.key === `Home` && (e.preventDefault(), this.reset()),
        e.key === `Escape` && (e.preventDefault(), this.deactivate()));
    }
  }
  let _ = new g();
  function v(e = ``) {
    let t = String(e).toLowerCase().replaceAll(`\xA0`, ` `);
    return /1000|1\s*l|1l/.test(t) ? `1000` : /500/.test(t) ? `500` : ``;
  }
  function y(e, t) {
    return v(
      e.dataset.threeOlivesFormat ||
        e.dataset.cartLine ||
        e.closest(`[data-cart-line]`)?.dataset.cartLine ||
        e.closest(`[data-cart-line-key]`)?.textContent ||
        t.alt ||
        t.currentSrc ||
        t.src,
    );
  }
  function b(e) {
    if (!e?.isConnected || e.hidden || e.closest(`[hidden]`)) return !1;
    let t = getComputedStyle(e);
    return (
      t.display !== `none` &&
      t.visibility !== `hidden` &&
      Number(t.opacity) !== 0
    );
  }
  function x(e) {
    return (
      [...e.querySelectorAll(`img`)].find(
        (e) => !e.closest(`.three-olives-270__overlay`),
      ) || null
    );
  }
  function S(e) {
    const t=d[e?.format];if(!t||i.replacePosters===false)return;
    const responsive=/\/3os-r(?:11|6)-/.test(t),width=Math.max(120,Math.ceil(e.poster.getBoundingClientRect().width||560));
    const srcset=responsive?[120,240,480,720,1120].map(w=>(w===1120?t:t.replace('-poster.webp','-'+w+'.webp'))+' '+w+'w').join(', '):t;
    const sizes=width+'px';
    const set=(n,k,v)=>{if(n.getAttribute(k)!==v)n.setAttribute(k,v);};
    e.poster.closest('picture')?.querySelectorAll('source').forEach(source=>{set(source,'srcset',srcset);set(source,'sizes',sizes);});
    set(e.poster,'src',t);set(e.poster,'srcset',srcset);set(e.poster,'sizes',sizes);set(e.poster,'decoding','async');
  }
  function C(e, t, n) {
    let r = document.createElement(`span`);
    ((r.className = `three-olives-270__overlay`),
      r.setAttribute(`data-three-olives-overlay`, ``));
    let a = document.createElement(`span`);
    ((a.className = `three-olives-270__mount`),
      a.setAttribute(`data-three-olives-mount`, ``));
    let o = document.createElement(`button`);
    ((o.className = `three-olives-270__activate`),
      (o.type = `button`),
      o.setAttribute(
        `aria-label`,
        `${i.hint || `Rotește sticla`} Picual ${n === `1000` ? `1 L` : `500 ml`} în 3D`,
      ));
    let s = document.createElement(`span`);
    ((s.className = `three-olives-270__controls`),
      (s.hidden = !0),
      (s.innerHTML = `<button type="button" data-three-olives-reset>Din față</button>`));
    let c = document.createElement(`span`);
    return (
      (c.className = `three-olives-270__status`),
      c.setAttribute(`role`, `status`),
      c.setAttribute(`aria-live`, `polite`),
      (c.textContent = `Imaginea produsului este afișată.`),
      r.append(a, o, s, c),
      e.append(r),
      { overlay: r, mount: a, activate: o, controls: s, status: c }
    );
  }
  function w(e) {
    let t = null,
      n = (n) => {
        if (!(!t || (n.pointerId !== void 0 && n.pointerId !== t.pointerId))) {
          try {
            e.activate.releasePointerCapture(t.pointerId);
          } catch {}
          t = null;
        }
      },
      r = () => (m ? _.prewarm(e) : !1);
    (e.activate.addEventListener(`pointerenter`, () => r(e), { passive: !0 }),
      e.activate.addEventListener(`focus`, () => r(e)),
      e.activate.addEventListener(`pointerdown`, (n) => {
        if (!(n.button !== void 0 && n.button !== 0)) {
          (_.activate(e, { focus: !1 }),
            (t = {
              pointerId: n.pointerId,
              x: n.clientX,
              y: n.clientY,
              lastX: n.clientX,
              axis: null,
            }));
          try {
            e.activate.setPointerCapture(n.pointerId);
          } catch {}
        }
      }),
      e.activate.addEventListener(
        `pointermove`,
        (r) => {
          if (!t || r.pointerId !== t.pointerId) return;
          let i = r.clientX - t.x,
            a = r.clientY - t.y;
          if (
            !t.axis &&
            Math.max(Math.abs(i), Math.abs(a)) >= 9 &&
            ((t.axis = Math.abs(i) > Math.abs(a) * 1.12 ? `rotate` : `scroll`),
            t.axis === `scroll`)
          ) {
            n(r);
            return;
          }
          t.axis === `rotate` &&
            (r.cancelable && r.preventDefault(),
            _.rotateByPixels(r.clientX - t.lastX, e),
            (t.lastX = r.clientX));
        },
        { passive: !1 },
      ),
      e.activate.addEventListener(`pointerup`, n),
      e.activate.addEventListener(`pointercancel`, n),
      e.activate.addEventListener(`keydown`, (t) => {
        ((t.key === `Enter` || t.key === ` `) &&
          (t.preventDefault(), _.activate(e, { focus: !1 })),
          (t.key === `ArrowLeft` || t.key === `ArrowRight`) &&
            (t.preventDefault(),
            _.activate(e, { focus: !1 }),
            _.rotateByPixels(t.key === `ArrowLeft` ? -26 : 26, e)),
          t.key === `Home` && (t.preventDefault(), _.reset()));
      }));
  }
  function T(e) {
    if(!e)return;
    S(e);
    let { stage: t, poster: n, overlay: r } = e;
    if (!t.isConnected || !n.isConnected) return;
    if (t.dataset.threeOlivesGrounded === 'true') {
      // This stage already IS the calibrated camera frame; do not cache an old
      // poster/viewport intersection across a responsive picture source change.
      r.hidden=false;
      Object.assign(r.style,{left:'0px',top:'0px',width:'100%',height:'100%'});
      return;
    }
    let i = t.getBoundingClientRect(),
      a = n.getBoundingClientRect();
    if (!i.width || !i.height || !a.width || !a.height) {
      r.hidden = !0;
      return;
    }
    let o = t.offsetWidth ? i.width / t.offsetWidth : 1,
      s = t.offsetHeight ? i.height / t.offsetHeight : 1,
      c = i.left + t.clientLeft * o,
      l = i.top + t.clientTop * s,
      u = c + t.clientWidth * o,
      d = l + t.clientHeight * s,
      f = Math.max(
        1,
        document.documentElement.clientWidth || window.innerWidth || 1,
      ),
      p = Math.max(a.left, c, 0),
      m = Math.max(a.top, l),
      h = Math.min(a.right, u, f),
      g = Math.min(a.bottom, d),
      _ = h - p,
      v = g - m;
    if (_ <= 0 || v <= 0) {
      r.hidden = !0;
      return;
    }
    ((r.hidden = !1),
      (r.style.left = `${(p - c) / (o || 1)}px`),
      (r.style.top = `${(m - l) / (s || 1)}px`),
      (r.style.width = `${_ / (o || 1)}px`),
      (r.style.height = `${v / (s || 1)}px`));
  }
  function E(t) {
    if (
      !(t instanceof HTMLElement) ||
      e.has(t) ||
      (t.closest(`[data-three-olives-editorial]`) || (window.__TOS290_ENABLED__ && t.dataset.threeOlivesFormat === `500`))
    )
      return;
    let n = x(t);
    if (!n) return;
    let r = y(t, n),
      s = u[r];
    if (!r || !s) return;
    let c =
      t.hasAttribute(`data-three-olives-compact`) ||
      Math.min(
        n.getBoundingClientRect().width || n.width,
        n.getBoundingClientRect().height || n.height,
      ) < 120;
    (getComputedStyle(t).position === `static` &&
      t.classList.add(`three-olives-270--positioned`),
      t.classList.add(`three-olives-270`),
      (t.dataset.threeOlivesViewerState = `poster`),
      n.classList.add(`three-olives-270__poster`));
    let d = C(t, n, r),
      f = {
        stage: t,
        poster: n,
        format: r,
        modelUrl: s,
        label: r === `1000` ? `1 L` : `500 ml`,
        compact: c,
        tone: t.dataset.threeOlivesTone || `sunlit`,
        fit: Number(t.dataset.threeOlivesFit || i.fit || 1.12),
        yaw: Number(t.dataset.threeOlivesYaw ?? -Math.PI / 2),
        zoom: t.dataset.threeOlivesZoom !== `false`,
        physicalScale: o[r] / a,
        pendingRotation: 0,
        ...d,
      };
    (e.set(t, f),
      S(f),
      w(f),
      f.controls
        .querySelector(`[data-three-olives-reset]`)
        .addEventListener(`click`, (e) => {
          (e.preventDefault(), e.stopPropagation(), _.reset());
        }),
      l.has(t) || (j.observe(t), l.add(t)),
      requestAnimationFrame(() => T(f)),
      n.addEventListener(`load`, () => T(f), { passive: !0 }),
      (h.enhanced = e.size));
  }
  function D(e) {
    if (!(e instanceof HTMLElement) || t.has(e)) return;
    let n = x(e);
    if (!n) return;
    let r = y(e, n),
      a = d[r];
    if (!r || !a || i.replacePosters === !1) return;
    let o = { stage: e, poster: n, format: r };
    (n.classList.add(`three-olives-270__poster`), S(o), t.add(e));
  }
  function O(e = document) {
    for (let [t, n, r] of [
      [`.cine-champion--500`, `500`, `sunlit`],
      [`.cine-champion--1000`, `1000`, `sunlit`],
    ])
      e.querySelectorAll?.(t).forEach((e) => {
        (e.setAttribute(`data-three-olives-stage`, ``),
          e.setAttribute(`data-three-olives-format`, n),
          e.setAttribute(`data-three-olives-tone`, r));
      });
    e.querySelectorAll?.(`.pd-sticky__thumb[data-pd-bottle]`).forEach((e) => {
      (e.setAttribute(`data-three-olives-poster-only`, ``),
        e.setAttribute(`data-three-olives-format`, v(e.dataset.pdBottle)));
    });
  }
  function k(e = document) {
    e.querySelectorAll?.(`.house-cart__visual, .cart-item__media`).forEach(
      (e) => {
        if (
          e.hasAttribute(`data-three-olives-skip`) ||
          e.hasAttribute(`data-three-olives-stage`)
        )
          return;
        let t = e.querySelector(`img`);
        if (!t) return;
        let n = `${e.closest(`[data-cart-line], [data-cart-line-key], .cart-item`)?.textContent || ``} ${t.alt || ``} ${t.currentSrc || t.src || ``}`,
          r = v(n);
        !r ||
          !/picual|3os-|3.olives|bottle|sticl/i.test(n) ||
          (e.setAttribute(`data-three-olives-stage`, ``),
          e.setAttribute(`data-three-olives-format`, r),
          e.setAttribute(`data-three-olives-tone`, `paper`),
          e.setAttribute(`data-three-olives-compact`, ``));
      },
    );
  }
  function A(t = document) {
    (syncProofScene(t), syncPodiumScenes(t), O(t),
      k(t),
      t.querySelectorAll?.(`[data-three-olives-poster-only]`).forEach(D),
      t.querySelectorAll?.(`[data-three-olives-stage]`).forEach(E));
    for (let [t, n] of e)
      t.isConnected ||
        (_.activeRecord === n && _.deactivate({ silent: !0 }), e.delete(t));
    h.enhanced = e.size;
  }
  let j = new IntersectionObserver(
      (t) => {
        for (let n of t) {
          let t = e.get(n.target);
          const podiumArt=t?.stage.dataset.threeOlivesGrounded==='true' && t.stage.closest('.cine-hero--formate,.p5-proofscape')?.querySelector('.room__art,.tos282-proof-art')?.getBoundingClientRect();
          const sceneVisible=podiumArt && podiumArt.bottom>0 && podiumArt.top<innerHeight;
          (t === _.activeRecord &&
            !n.isIntersecting &&
            !sceneVisible &&
            _.deactivate({ silent: !0 }),
            n.isIntersecting && T(t));
        }
      },
      { rootMargin: `160px 0px`, threshold: 0 },
    ),
    M = 0,
    N = new MutationObserver(() => {
      M ||= requestAnimationFrame(() => {
        ((M = 0), A(), e.forEach(T));
      });
    });
  (A(),
    N.observe(document.documentElement, {
      childList: !0,
      subtree: !0,
      attributes: !0,
      attributeFilter: [`hidden`, `data-active`, `aria-hidden`],
    }),
    window.addEventListener(`resize`, () => e.forEach(T), { passive: !0 }),
    document.addEventListener('three-olives:podium-layout', event => {
      for (const record of e.values()) if (event.target.contains(record.stage)) T(record);
      if (_.activeRecord && event.target.contains(_.activeRecord.stage)) _.resize();
    }, true),
    window.addEventListener(`pagehide`, () => _.deactivate({ silent: !0 })),
    document.addEventListener(`keydown`, (e) => {
      e.key === `Escape` && _.activeRecord && _.deactivate();
    }),
    document.addEventListener(
      `pointerdown`,
      (e) => {
        _.activeRecord &&
          !_.activeRecord.stage.contains(e.target) &&
          _.deactivate({ silent: !0 });
      },
      !0,
    ),
    document.addEventListener(`shopify:section:load`, () => A()),
    (window.__THREE_OLIVES_270_R2__ = {
      metrics: h,
      viewer: _,
      records: e,
      scan: A,
      get activeFormat() {
        return _.activeRecord?.format || null;
      },
      get activeStage() {
        return _.activeRecord?.stage || null;
      },
      get intentPrewarmAllowed() {
        return m;
      },
      get reducedMotion() {
        return p.matches;
      },
    }));
}
